/* eslint-disable global-require */

export default {
  homescapes: [
    {
      type: 'image',
      title: 'Homescapes gameplay 1',
      link: require('@/assets/images/homescapes/preview/en/preview-01.webp'),
    },
    {
      type: 'image',
      title: 'Homescapes gameplay 2',
      link: require('@/assets/images/homescapes/preview/en/preview-02.webp'),
    },
    {
      type: 'image',
      title: 'Homescapes gameplay 3',
      link: require('@/assets/images/homescapes/preview/en/preview-03.webp'),
    },
    {
      type: 'image',
      title: 'Homescapes gameplay 4',
      link: require('@/assets/images/homescapes/preview/en/preview-04.webp'),
    },
    {
      type: 'image',
      title: 'Homescapes gameplay 5',
      link: require('@/assets/images/homescapes/preview/en/preview-05.webp'),
    },
    {
      type: 'image',
      title: 'Homescapes gameplay 6',
      link: require('@/assets/images/homescapes/preview/en/preview-06.webp'),
    },
    {
      type: 'image',
      title: 'Homescapes gameplay 7',
      link: require('@/assets/images/homescapes/preview/en/preview-07.webp'),
    },
  ],
  township: [
    {
      type: 'image',
      title: 'Township gameplay 1',
      link: require('@/assets/images/township/preview/en/preview-01.webp'),
    },
    {
      type: 'image',
      title: 'Township gameplay 2',
      link: require('@/assets/images/township/preview/en/preview-02.webp'),
    },
    {
      type: 'image',
      title: 'Township gameplay 3',
      link: require('@/assets/images/township/preview/en/preview-03.webp'),
    },
    {
      type: 'image',
      title: 'Township gameplay 4',
      link: require('@/assets/images/township/preview/en/preview-04.webp'),
    },
    {
      type: 'image',
      title: 'Township gameplay 5',
      link: require('@/assets/images/township/preview/en/preview-05.webp'),
    },
  ],
};
